import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=1ff17e81&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
import style0 from "./SearchFilterTokens.vue?vue&type=style&index=0&id=1ff17e81&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ff17e81",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1ff17e81')) {
      api.createRecord('1ff17e81', component.options)
    } else {
      api.reload('1ff17e81', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=1ff17e81&scoped=true&", function () {
      api.rerender('1ff17e81', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-27PxknmH63rZn/JS/comp/SearchFilterTokens.vue"
export default component.exports